import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { CartUIProvider } from './contexts/CartUIContext';
import { OrderProvider } from './contexts/OrderContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { OvenProvider } from './contexts/OvenContext';

// Layouts
import ClientLayout from './components/layout/ClientLayout';
import AdminLayout from './components/layout/AdminLayout';
import DriverLayout from './components/layout/DriverLayout';

// Auth
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';

// Client
import Home from './pages/client/Home';
import Products from './pages/client/Products';
import Cart from './pages/client/Cart';
import Checkout from './pages/client/Checkout';
import OrderTracking from './pages/client/OrderTracking';
import OrderHistory from './pages/client/OrderHistory';

// Admin
import AdminDashboard from './pages/admin/Dashboard';
import AdminProducts from './pages/admin/Products';
import AdminOrders from './pages/admin/Orders';
import AdminUsers from './pages/admin/Users';
import AdminDrivers from './pages/admin/Drivers';
import AdminSettings from './pages/admin/Settings';

// Driver
import DriverDashboard from './pages/driver/Dashboard';
import DriverOrders from './pages/driver/Orders';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <CartProvider>
            <CartUIProvider>
              <OrderProvider>
                <OvenProvider>
                  <Routes>
                    {/* ===== AUTH ===== */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />

                    {/* ===== CLIENTE ===== */}
                    <Route path="/" element={<ClientLayout />}>
                      <Route index element={<Home />} />
                      <Route path="productos" element={<Products />} />
                      <Route path="carrito" element={<Cart />} />
                      <Route path="checkout" element={<Checkout />} />
                      <Route path="pedido/:id" element={<OrderTracking />} />
                      <Route path="historial" element={<OrderHistory />} />
                    </Route>

                    {/* ===== ADMIN ===== */}
                    <Route path="/admin" element={<AdminLayout />}>
                      <Route index element={<AdminDashboard />} />
                      <Route path="productos" element={<AdminProducts />} />
                      <Route path="pedidos" element={<AdminOrders />} />
                      <Route path="usuarios" element={<AdminUsers />} />
                      <Route path="motorizados" element={<AdminDrivers />} />
                      <Route path="configuracion" element={<AdminSettings />} />
                    </Route>

                    {/* ===== MOTORIZADO ===== */}
                    <Route path="/driver" element={<DriverLayout />}>
                      <Route index element={<DriverDashboard />} />
                      <Route path="pedidos" element={<DriverOrders />} />
                    </Route>

                    {/* ===== 404 ===== */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </OvenProvider>
              </OrderProvider>
            </CartUIProvider>
          </CartProvider>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
